export function isRepeatSpec(spec) {
    return spec['repeat'] !== undefined;
}
//# sourceMappingURL=repeat.js.map